import React, { useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

export default function SetupStudio() {
  const { studioSetup } = useAuth();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    try {
      await studioSetup(f);
      toast.success("Welcome to Studio V, Director!");
      window.location.href = "/dashboard";
    } catch (err) {
      toast.error(err.response?.data?.detail || "Setup failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black p-6">
      <div className="w-full max-w-md bg-white rounded-3xl p-8 shadow-2xl">
        <div className="flex flex-col items-center text-center mb-6">
          <img src="/logo.png" alt="Studio V" className="w-20 h-20 rounded-2xl object-contain mb-3" />
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-teal-dark bg-teal-light px-3 py-1 rounded-full"><Sparkles className="w-3.5 h-3.5" />First-time setup</span>
          <h1 className="font-head text-3xl font-extrabold tracking-tight mt-3">Set Up Your Studio</h1>
          <p className="text-muted-foreground mt-1.5 text-sm">Create the first Director account. This one-time step unlocks full administrative access, then it's permanently disabled.</p>
        </div>

        <button data-testid="setup-google-button" onClick={handleGoogle}
          className="w-full flex items-center justify-center gap-3 bg-white border border-gray-200 rounded-full py-3.5 font-semibold hover:shadow-md transition-all">
          <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="" className="w-5 h-5" />Set up with Google
        </button>

        <div className="flex items-center gap-3 my-6">
          <div className="h-px bg-gray-200 flex-1" /><span className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">or use email</span><div className="h-px bg-gray-200 flex-1" />
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div><label className="text-sm font-semibold">Your name</label><Input data-testid="setup-name" value={f.name} onChange={(e) => set("name", e.target.value)} className="mt-1.5 rounded-xl" /></div>
          <div><label className="text-sm font-semibold">Email</label><Input data-testid="setup-email" type="email" value={f.email} onChange={(e) => set("email", e.target.value)} className="mt-1.5 rounded-xl" /></div>
          <div><label className="text-sm font-semibold">Password</label><Input data-testid="setup-password" type="password" value={f.password} onChange={(e) => set("password", e.target.value)} className="mt-1.5 rounded-xl" placeholder="min 6 characters" /></div>
          <button type="submit" data-testid="setup-submit" className="w-full bg-teal hover:bg-teal-dark text-white rounded-full py-3.5 font-semibold transition-colors">Create Director Account</button>
        </form>
      </div>
    </div>
  );
}
